import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Input, Button, Upload, Icon, message, Modal} from "antd";
import { getInfoFromLocalStorage } from "../../../../../../actions";
import {BaseComponent} from '@cm-sites-webber/components';
import {PIC_TYPE_PDF} from '@cm-sites-webber/components/es/constants';
import close from "../img/close.png";

import './style.css';

const InputProps = {...Input.defaultProps, ...Input.propTypes}

/**
 * uploadIcon组件
 */
class UploadIcon extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            loading: false,
            value: "",
        };
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.updateValue();
    }

    componentWillUnmount() {
        // 解决异常组件卸载调用setState
        this.setState = () => {
        }
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(UploadIcon.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if (Array.isArray(props.fieldProps?.extra) && !props.fieldProps?.extra.includes(fieldKey)) {
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }

    componentDidUpdate(preProps, preState) {
        if (this.props.fieldProps?.value !== preProps.fieldProps?.value && this.props.fieldProps?.value !== this.state.fieldProps.value) {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }

    renderSuffixButton() {
        const {buttonProps = {}} = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    render() {
        const {
            prefixLayout,
            suffixLayout,
            style = {},
            suffixButton,
            disabled,
            formInfoData,
            isAuditing,
            positionId,
            onlyEdit
        } = this.props.fieldProps;
        const {fieldProps, suffixWidth, value, loading} = this.state;
        const positionCreator = `${formInfoData.belongUserName || "暂无"}${formInfoData.belongDeptName ? `（${formInfoData.belongDeptName}）` : ''}`;
        // （审核中 || 审核不通过）&& 审核意见存在   =》  展示查看审核意见
        let showAuditOpinion = (isAuditing || formInfoData?.statusName?.indexOf("审核不通过") > -1) && formInfoData?.remarks;
        const PIC_TYPE = ["jpg", "jpeg", "gif", "png", "bmp"];
        const PIC_TYPE_NEW = [...PIC_TYPE, ...PIC_TYPE.toUpperCase()];//图片
        let Token = getInfoFromLocalStorage('Token');

        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout && <div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={{...style, flexGrow: 0, position: "relative"}}>
                        <Upload
                            {...fieldProps}
                            name="file"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            accept={"." + [...PIC_TYPE_NEW].join(",.")}
                            beforeUpload={(file) => {
                                this.setState({
                                    loading: true,
                                })
                                let fileName = file.name.split('.');
                                let upload = fileName.at(-1).toUpperCase();
                                upload = PIC_TYPE_NEW.includes(upload);
                                if (!upload) {
                                    message.error('暂不支持该文件类型！');
                                }
                                return new Promise((resolve, reject) => {
                                    if (!upload) {
                                        this.setState({
                                            loading: false
                                        })
                                        reject(file);
                                    } else {
                                        resolve(file);
                                    }
                                });
                            }}
                            action="/dynamic/storage/uploadFile"
                            headers={{Authorization: 'Bearer ' + Token}}
                            onSuccess={(response, file) => {
                                if (response && response.status === 200) {
                                    let logo = response?.data?.smallPath ? response?.data?.smallPath : null;
                                    if (typeof this.props.fieldProps.onChange === "function") {
                                        this.setState({
                                            value: logo,
                                        })
                                        this.props.fieldProps.onChange(logo)
                                    }
                                }
                                this.setState({
                                    loading: false,
                                })
                            }}
                            onError={() => {
                                this.setState({
                                    loading: false,
                                })
                            }}
                            disabled={disabled}
                        >
                            <div style={{width: "100%", aspectRatio: 1}}>
                                {
                                    value && !loading ?
                                        <img src={value} alt="avatar" style={{
                                            width: '56px',
                                            height: '56px',
                                            lineHeight: "52px",
                                            borderRadius: "50%",
                                            objectFit: 'cover'
                                        }}/> : loading ? <Icon type={'loading'}/> : <div style={{
                                            width: "56px",
                                            aspectRatio: "1",
                                            borderRadius: "50%",
                                            background: "rgba(0,80,179,0.08)",
                                        }}>
                                            <Icon type={loading ? 'loading' : 'plus'}/>
                                        </div>
                                }
                            </div>
                            {!loading && !disabled &&
                                <div style={{
                                    position: "absolute",
                                    right: 12,
                                    bottom: 0,
                                    fontSize: 12,
                                    color: "#999",
                                }}>{value ? "重新上传" : !loading ? "上传Logo" : ""}</div>}
                        </Upload>
                        {value && !loading && !disabled && <img src={close}
                                                   style={{
                                                       position: "absolute",
                                                       right: 0,
                                                       top: -8,
                                                       cursor: "pointer",
                                                       width: 18,
                                                       height: 18,
                                                   }}
                                                   onClick={() => {
                                                       this.setState({
                                                           value: "",
                                                       })
                                                       this.props.fieldProps.onChange("")
                                                   }}
                        />}
                    </div>
                    {
                        (!!suffixLayout && !value) && <div className="rmt-input-suffix-layout">
                            <div>{suffixLayout}</div>
                        </div>
                    }
                    {
                        !onlyEdit && positionId && <div style={{marginTop: showAuditOpinion ? 8 : 14}}>
                            <div style={{lineHeight: showAuditOpinion ? "23px" : "28px"}}>
                                <div style={{display: "flex"}}>
                                    <div style={{
                                        fontWeight: 500,
                                        display: "inline-block",
                                        width: 70
                                    }}>账号状态：
                                    </div>
                                    <div title={formInfoData.statusName} style={{
                                        maxWidth: 160,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>
                                        {formInfoData.statusName}
                                    </div>
                                    <div>
                                        {isAuditing ? `（${formInfoData.processName}）` : ''}
                                    </div>
                                </div>
                                <div style={{display: "flex"}}>
                                    <div style={{
                                        fontWeight: 500,
                                        display: "inline-block",
                                        width: 85
                                    }}>账号所属人：
                                    </div>
                                    <div title={positionCreator} style={{
                                        maxWidth: 180,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>
                                        {positionCreator}
                                    </div>
                                </div>
                                {showAuditOpinion && <div>
                                    <span style={{color: "#0050B3", cursor: "pointer"}} onClick={() => {
                                        Modal.info({
                                            title: formInfoData.remarks,
                                            okText: "关闭",
                                            okType: "default"
                                        });
                                    }}>查看审核意见</span>
                                </div>}
                            </div>
                        </div>
                    }
                </div>
                <style>{`
                                            .rmt-input-content-layout .ant-upload.ant-upload-select-picture-card{width:56px;height:56px;line-height: 52px;}
                                            .rmt-input-content-layout .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                                            .rmt-input-content-layout .ant-upload.ant-upload-select-picture-card #logo{width:56px;height:56px;line-height: 52px;border-radius: 50%;
                                                            background: rgba(0,80,179,0.0800);}
                                            .avatar-uploader .anticon svg{width: 30px;height: 30px;margin-top: ${loading ? "3px" : "13px"}; color: #0050B3;}
                            `}
                </style>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        } else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}

export default UploadIcon;

UploadIcon.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

UploadIcon.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: () => {
    }
}